import {useSelector} from "react-redux";

const useStateSelector = () => useSelector(state => state);

export {
  useStateSelector
}